(function () {
    'use strict';

    angular
        .module('elogbooks.user.my-details')
        .config(registerRoutes)
        .config(registerGeneralRoutes)
    ;

    function registerRoutes($stateProvider) {
        $stateProvider
        .state('dashboard.user.my-details', {
            abstract: true,
            templateUrl: '/shared-templates/view.html',
            ncyBreadcrumb: {
                skip: true
            }
        });
    }

    function registerGeneralRoutes($stateProvider) {
        $stateProvider
            .state('dashboard.user.my-details.info', {
                url: '/my-details',
                parent: 'dashboard.user.my-details',
                resolve: {
                    userResponse: function (user) {
                        return user;
                    },
                    rootResourceResponse: function (rootResourceResponse) {
                        return rootResourceResponse;
                    }
                },
                views: {
                    '@dashboard.user.my-details': {
                        templateUrl: '/modules/user/my-details/info/my-details-info.html',
                        controller: 'UserMyDetailsInfoController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: '{{ ::"MY_DETAILS" | translate }}'
                }
            })
            .state('dashboard.user.my-details.info.edit', {
                url: '/edit',
                parent: 'dashboard.user.my-details.info',
                resolve: {
                    userResponse: function (user) {
                        return user;
                    }
                },
                views: {
                    '@dashboard.user.my-details': {
                        templateUrl: '/modules/user/my-details/info/edit/my-details-edit.html',
                        controller: 'UserMyDetailsEditController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: '{{ ::"EDIT" | translate }}'
                }
            });
    }
})();
